export default {
  lang: 'English',
  loginView: {
    title: 'Travel Professional Training and Sales Enablement Program',
    newUser: 'New User',
  },
  register: {
    agency: 'Agency',
    email: 'Email',
    firstName: 'First name',
    lastName: 'Last name',
    agencyName: 'Agency name',
    state: 'State',
    back: 'Back',
    register: 'Register',
  },
  directory: {
    search: 'Search directory',
    placesAndDestinations: 'Places and Destinations',
  },
  footer: {
    legal: 'Legal',
    customerService: 'Customer Service',
    contact: 'Contact',
    poweredBy: 'Powered by: {TravProMobile}',
  },
  sellingPoints: {
    0: 'All new content, insider tips, videos and more',
    1: 'Enhance your knowledge, increase your sales',
    2: 'Incentives (by market) for completion of program',
    3: 'Links to social media channels',
    4: 'Easy to use tools to help you sell more',
  },
  email: {
    email: 'Email',
    agent: 'I\'m not an agent',
    submit: 'Submit',
    headerTop: 'Please enter your email address to confirm that you are',
    headerBottom: 'a travel professional.',
    welcome: {
      headerTop: 'Welcome to the',
      headerBottom: 'Barceló Sales Companion!',
    },
  },
  loginForm: {
    registered: 'The email address is already registered',
  },
  home: {
    experience: 'React Demo',
    caribbean: 'Sales Companion',
    search: 'Search...',
    welcome: {
      super: 'Start',
      title: 'Training',
      button: 'Start Training',
    },
    essentials: 'Learn the essentials to become a great Travel Agent',
    searchDirectory: 'Search directory',
  },
  fastFacts: {
    contentHeader: {
      title: 'FAST FACTS',
      subtitle: 'Download items and suggestions',
    },
    view: 'View',
  },
  dropdown: {
    reportCard: 'Report Card',
    settings: 'Settings',
    logOut: 'Log out',
  },
  nav: {
    home: 'Home',
    training: 'Training',
    fastFacts: 'Fast Facts',
    toolbox: 'Toolbox',
    directory: 'Directory',
    profile: 'Profile',
    search: 'Search',
    favorites: 'Favorites',
    logout: 'Logout',
    searchDirectory: 'Search directory',
    reportcard: 'Reportcard',
    accountSettings: 'Account Settings',
    profileImage: 'Profile Image',
    help: 'Help',
  },
  trainingCard: {
    minutes: ' pages in this training',
    retain: 'View Training page',
    start: 'View Training page',
    continue: 'View Training page',
  },
  trainingContent: {
    next: 'Next',
    previous: 'Previous',
    overview: 'Return to overview',
    confirm: 'Confirm answer',
  },
  pageNotFound: {
    super: 'Uh oh...',
    title: '404 Page Not Found!',
    button: 'Home',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    button: 'Login',
  },
  test: 'Do not translate - never seen',
};
